import React from 'react';
import { Heading, Text } from '@fiverr-private/typography';
import { CURRENCY_STYLES, currencyFormat } from '@fiverr-private/localization';
import { Stack } from '@fiverr-private/layout_components';
import { PricingDetails } from '../../../../type';
import { appTranslate } from '../../../i18n';

interface DiscountedPricingProps {
    pricingDetails?: PricingDetails;
}

export const DiscountedPricing = ({ pricingDetails }: DiscountedPricingProps) => {
    if (!pricingDetails?.price) {
        return null;
    }

    return (
        <Stack rowGap="4" direction="column">
            <Stack rowGap="1" direction="column">
                <Heading as="h4" size="h_md" whiteSpace="nowrap">
                    {currencyFormat({
                        value: pricingDetails.price.discountedAmountMonthly,
                        currencyCode: pricingDetails.price.currency,
                        options: {
                            maximumFractionDigits: 2,
                            style: CURRENCY_STYLES.SYMBOL,
                        },
                    })}
                </Heading>
                <Text size="b_sm" color="bodySecondary">
                    {appTranslate('compare_packages.microsoft.pricing.billing_cycle.yearly')}
                </Text>
            </Stack>

            <Text size="b_sm">
                {appTranslate('compare_packages.microsoft.pricing.renewal_note', {
                    params: {
                        renewalPrice: currencyFormat({
                            value: pricingDetails.price.amountMonthly,
                            currencyCode: pricingDetails.price.currency,
                            options: {
                                maximumFractionDigits: 2,
                                style: CURRENCY_STYLES.SYMBOL,
                            },
                        }),
                    },
                })}
            </Text>
        </Stack>
    );
};
